import { configureStore } from "@reduxjs/toolkit";

import currentPlayerReducer from "./currentPlayerSlice";
import diceReducer from "./diceSlice";
import gameBoardReducer from "./gameBoardSlice";
import gameStateReducer from "./gameStateSlice";
import lastPointClickedReducer from "./lastPointClickedSlice";
import provisionalMovesReducer from "./provisionalMovesSlice";
import settingsReducer from "./settingsSlice";
import playersSliceReducer from "./playersSlice";
import animatableMovesReducer from "./animatableMovesSlice";
import doublingCubeReducer from "./doublingCubeSlice";
import matchScoreReducer from "./matchScoreSlice";
import wipeTransitionReducer from "./wipeTransitionSlice";
import readyForNextGameReducer from "./readyForNextGameSlice";
import userReducer from "./userSlice";
import toastReducer from "./toastSlice";
import betReducer from "./betSlice";

export const store = configureStore({
  reducer: {
    gameBoard: gameBoardReducer,
    gameState: gameStateReducer,
    lastPointClicked: lastPointClickedReducer,
    provisionalMoves: provisionalMovesReducer,
    dice: diceReducer,
    currentPlayer: currentPlayerReducer,
    players: playersSliceReducer,
    settings: settingsReducer,
    animatableMoves: animatableMovesReducer,
    doublingCube: doublingCubeReducer,
    matchScore: matchScoreReducer,
    wipeTransition: wipeTransitionReducer,
    readyForNextGame: readyForNextGameReducer,
    user: userReducer,
    toast: toastReducer,
    bet: betReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Экспонируем store в window для доступа из класс-акшенов (бот)
if (typeof window !== "undefined") {
  (window as any).__BG_STORE__ = store;
}
